import { useContext, useEffect, useMemo } from 'react';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { FILTERS_PROVIDER_STORAGE_KEYS } from '../contexts';
import { STORAGE_TYPES } from 'common/constants/constants';

const STORAGE_TYPE = STORAGE_TYPES.LOCAL;
const storageAccessor = BrowserStorageAccessor()[STORAGE_TYPE];

const useStoragePersist = ({ Context }) => {
  const storageKeys = useMemo(() => Context.storageKeys, [Context]);
  if (storageKeys === undefined)
    throw new Error('FiltersProvider is missing Context.storageKeys');

  const { state } = useContext(Context);
  const { period, filters, selectedFilterSetId, isInitialized } = state;

  useEffect(() => {
    if (!isInitialized) return;
    storageAccessor.set(
      storageKeys[FILTERS_PROVIDER_STORAGE_KEYS.PERIOD],
      JSON.stringify(period)
    );
  }, [isInitialized, period]);

  useEffect(() => {
    if (!isInitialized) return;
    storageAccessor.set(
      storageKeys[FILTERS_PROVIDER_STORAGE_KEYS.FILTERS],
      JSON.stringify(filters)
    );
  }, [isInitialized, filters]);

  useEffect(() => {
    if (!isInitialized) return;
    storageAccessor.set(
      storageKeys[FILTERS_PROVIDER_STORAGE_KEYS.SELECTED_FILTER_SET_ID],
      selectedFilterSetId
    );
  }, [isInitialized, selectedFilterSetId]);
};

export default useStoragePersist;
